import Vue from 'vue'
import Vuex from 'vuex'
import query from '@/vuex/query'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    query
  }
})

export default store
